<template>
    <div class="trade-references">
        <b-card no-body class="p-3">
            <b-row align-v="center">
                <b-col cols="6">
                    <h3 class="mb-0">
                        Trade References
                    </h3>
                </b-col>
                <b-col cols="6">
                    <span v-if="trade_reff_issue.length > 0" class="float-right font-weight-600 text-danger">{{ trade_reff_issue.length }} Issue{{ trade_reff_issue.length > 1 ? 's' : '' }}</span>
                    <span v-else class="float-right text-muted">No Issue</span>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import { Card, Button } from 'element-ui'
import { mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'

export default {
    name: 'trade-references',
    components: {
        [Card.name]: Card,
        [Button.name]: Button,
    },
    data() {
        return {
            trade_reff_issue: '',
        }
    },
    computed:{
        ...mapState(useCustomerStore, ['current_commitment'])
    },
    watch: {
        current_commitment: {
            handler(newVal){
                if(newVal){
                    this.trade_reff_issue = newVal.credit_report_summary.trade_references
                }
            }
        }
    }
}
</script>